export enum AdminBlogEndpoints {
   ById = '/admin/blog-posts/:id',
   Create = '/admin/blog-posts',
   AllBlogPosts = '/admin/blog-posts'
}